import './ButtonBase-0764b242.css';

var classes = {"ButtonBase":"prc-Button-ButtonBase-c50BI","CounterLabel":"prc-Button-CounterLabel-f5-4u","Visual":"prc-Button-Visual-2epfX","VisualWrap":"prc-Button-VisualWrap-Db-eB","IconButton":"prc-Button-IconButton-szpyj","ButtonContent":"prc-Button-ButtonContent-HKbr-","Label":"prc-Button-Label-pTQ3x","LoadingSpinner":"prc-Button-LoadingSpinner-hLV6o","ConditionalWrapper":"prc-Button-ConditionalWrapper-WLT4Z"};

export { classes as default };
